import { applyMiddleware, compose, createStore as createReduxStore } from 'redux';
import { persistStore, autoRehydrate } from 'redux-persist';
import localForage from 'localforage';
import thunk from 'redux-thunk';
import apiService from '../utils/api/apiService';
import makeRootReducer from './reducers';

function createPersistor(store) {
  return new Promise((resolve) => {
    persistStore(store, { storage: localForage, blacklist: ['workoutPage'] }, () => {
      const state = store.getState();
      apiService.setAuthentication(state.app.authKey);
      resolve(store);
    });
  });
}
async function createStore(initialState = {}) {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const middleware = [thunk];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [autoRehydrate()];
  let composeEnhancers = compose;

  if (__DEV__) {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================

  const store = createReduxStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware),
      ...enhancers,
    ),
  );
  store.asyncReducers = {};

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default; // eslint-disable-line global-require
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }
  await createPersistor(store);
  return store;
}

export default createStore;
